import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isFormLocked?: boolean }>()(theme => ({
  onboardingActions: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  autosave: {
    display: 'flex',
    alignItems: 'center',
  },
  root: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
  btnWrapper: {
    display: 'flex',
    gap: theme.spacing(3),
    marginRight: theme.spacing(8),
  },
  disableBtn: {
    cursor: 'not-allowed',
  },
  disableEvents: {
    pointerEvents: 'none',
  },
}))
